export default "__VITE_ASSET__Bt6Vea0q__"